import React, {useContext} from 'react';
import { Dropdown } from 'antd';
import { PersonAddRounded, PlaylistAddRounded, PlaylistRemoveRounded } from "@mui/icons-material";
import Tooltip from "@common/Tooltip";
import axios from "@common/axios";
import {UserContext} from "@context/UserContext";

const ManageUsersDropdown = ({
                                 classDetails,
                                 handleAddStudent,
                                 handleRefreshClasses,
                                 addUserTooltipText = 'Add user',
                                 usersClass = true,
                                 renderTrigger = null,
                                 placement = 'top'
                             }) => {
    const { className, classId } = classDetails ?? {},
        {updateUserClasses} = useContext(UserContext);

    const handleAddRemoveClass = async () => {
        try {
            await axios.post('/web/ui/myClasses/updateTeacherClass', classId, {
                headers: {'Content-Type': 'application/json'}
            });
            return true;
        } catch (error) {
            const msg =
                error.response?.data?.message ||
                'Unable to change class users. Try the action again.';
            displayToastMessage(msg, error, 'error', undefined, 10000);
            return false;
        }
    };

    const handleMenuClick = async ({ key }) => {
        switch (key) {
            case 'manage':
                handleAddStudent?.(classDetails);
                break;

            case 'join': {
                const ok = await handleAddRemoveClass();
                if (ok) {
                    displayToastMessage(`You're now a teacher of ${className}`, null, 'success', undefined, 10000);
                    handleRefreshClasses?.();
                    updateUserClasses();
                }
                break;
            }

            case 'leave': {
                const ok = await handleAddRemoveClass();
                if (ok) {
                    displayToastMessage(`You're no longer a teacher of ${className}`, null, 'success', undefined, 10000);
                    handleRefreshClasses?.();
                    updateUserClasses();
                }
                break;
            }

            default:
                break;
        }
    };

    const menuItems = [
        {
            key: 'manage',
            label: 'Edit class users',
            icon: <PersonAddRounded fontSize="large" />
        },
        {
            key: usersClass ? 'leave' : 'join',
            label: usersClass ? 'Remove class from My Classes' : 'Add class to My Classes',
            icon: usersClass ? <PlaylistRemoveRounded fontSize="large" /> : <PlaylistAddRounded fontSize="large" />
        },
    ];

    const defaultTrigger = (
        <Tooltip title={addUserTooltipText}>
            <button
                type="button"
                aria-label="Add user"
                data-gtm-value="classes-add-user"
            >
                <PersonAddRounded />
            </button>
        </Tooltip>
    );

    return (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={['click']}
            placement={placement}
            disabled={!classId}
        >
            <span className="ch-dropdown-button">
                {renderTrigger || defaultTrigger}
            </span>
        </Dropdown>
    );
};

export default ManageUsersDropdown;
